import { Mesh } from "three";
import { useFrame } from "@react-three/fiber";
import { useMemo, useRef } from "react";
import { MeshFeatureContextHook } from "../MeshFeatureContext";

export const useSpriteAnimate: MeshFeatureContextHook = (
  mesh: Mesh,
  userData = {}
) => {
  const { SpriteAnimate: unprocessedSpeed = 1 } = userData;
  const speed = useMemo(
    () => parseFloat(`${unprocessedSpeed}`),
    [unprocessedSpeed]
  );
  const currentFrameRef = useRef(1);
  const lastFrame = useMemo(() => {
    if (mesh && mesh.children?.length > 0) {
      return mesh.children.length;
    }
    return 1;
  }, [mesh]);

  useFrame(() => {
    if (mesh && mesh.children?.length > 0) {
      const currentFrame = Math.floor(currentFrameRef.current);

      for (let i = 0; i < mesh.children.length; i++) {
        mesh.children[i].visible = i + 1 === currentFrame;
      }

      currentFrameRef.current += speed;

      if (currentFrame > lastFrame) {
        currentFrameRef.current = 1;
      }
    }
  });
};
